import { Controller } from "@hotwired/stimulus"
import { safeStorageGet, safeStorageSet } from "../utils/safe_storage"

const STORAGE_KEY = "thingShowReturnTo"
const SEARCH_RESULTS_PATH = "/search/results"

export default class extends Controller {
  static values = {
    path: String,
    apply: { type: Boolean, default: false }
  }

  connect() {
    if (!this.applyValue) return

    const stored = this.safeInternalPath(safeStorageGet(sessionStorage, STORAGE_KEY))
    if (!stored) return

    const storedPathname = this.pathWithoutQueryOrHash(stored)
    if (storedPathname === window.location.pathname) return
    if (!this.shouldApplyStored(stored)) return

    this.element.setAttribute("href", stored)
  }

  remember() {
    if (!this.hasPathValue) return

    const path = this.safeInternalPath(this.pathValue)
    if (!path) return

    safeStorageSet(sessionStorage, STORAGE_KEY, path)
  }

  shouldApplyStored(stored) {
    const referrerPath = this.sameOriginReferrerPath()
    if (!referrerPath) return true

    const referrerPathname = this.pathWithoutQueryOrHash(referrerPath)
    if (referrerPathname === window.location.pathname) return true

    return this.normalizedListingPath(referrerPath) === this.normalizedListingPath(stored)
  }

  sameOriginReferrerPath() {
    const referrer = document.referrer
    if (!referrer) return null

    try {
      const url = new URL(referrer)
      if (url.host !== window.location.host) return null

      return `${url.pathname}${url.search}${url.hash}`
    } catch {
      return null
    }
  }

  normalizedListingPath(path) {
    const pathname = this.pathWithoutQueryOrHash(path)
    if (pathname !== SEARCH_RESULTS_PATH) return path

    return `/search${path.slice(pathname.length)}`
  }

  safeInternalPath(value) {
    if (typeof value !== "string") return null

    const trimmed = value.trim()
    if (!trimmed.startsWith("/") || trimmed.startsWith("//") || trimmed.includes("\\")) {
      return null
    }

    return trimmed
  }

  pathWithoutQueryOrHash(path) {
    return path.split(/[?#]/, 1)[0]
  }
}
